import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface DocumentEditLockToastData {
  ownerName: string;
}

@Component({
  selector: 'app-document-edit-lock-toast',
  templateUrl: './document-edit-lock-toast.component.html',
  styleUrls: ['./document-edit-lock-toast.component.scss'],
  standalone: false,
})
export class DocumentEditLockToastComponent {
  readonly escapedOwnerName: string;
  readonly messageKey: string;

  constructor(
    private snackBarRef: MatSnackBarRef<DocumentEditLockToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) data: DocumentEditLockToastData
  ) {
    this.escapedOwnerName = this.escapeHtml(data.ownerName);
    this.messageKey = data.ownerName
      ? 'documentCurrentlyBeingEdited'
      : 'documentCurrentlyBeingEditedAnonymous';
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
